// Generated by purs version 0.15.0
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Tracking_Event from "../Restaumatic.Analytics.Tracking.Event/index.js";
var itemValue = function (v) {
    return Data_Money_Rounded.toNumber(v.price) * Data_Int.toNumber(v.quantity);
};
var convertItem = function (v) {
    return {
        item_name: v.name,
        quantity: v.quantity,
        price: Data_Money_Rounded.toNumber(v.price),
        item_category: v.category,
        item_list_id: Data_Functor.map(Data_Maybe.functorMaybe)(Data_Show.show(Restaumatic_Analytics_Tracking_Event.showItemList))(v.list)
    };
};
var toPlatformEvent = function (currency) {
    var setCheckoutOption = function (v) {
        return {
            selectedOption: v.selectedOption,
            selectedValue: v.selectedValue
        };
    };
    var removeFromCart = function (item) {
        return {
            currency: currency,
            value: itemValue(item),
            items: [ convertItem(item) ]
        };
    };
    var purchase = function (v) {
        return {
            items: Data_Functor.map(Data_Functor.functorArray)(convertItem)(v.items),
            value: Data_Money_Rounded.toNumber(v.total),
            currency: currency,
            affiliation: v.affiliation,
            shipping: Data_Money_Rounded.toNumber(v.shipping),
            transaction_id: v.transactionId,
            coupon: v.coupon
        };
    };
    var beginCheckout = function (v) {
        return {
            items: Data_Functor.map(Data_Functor.functorArray)(convertItem)(v.items),
            value: Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveNumber)(Data_Functor.map(Data_Functor.functorArray)(itemValue)(v.items)),
            currency: currency
        };
    };
    var addToCart = function (item) {
        return {
            currency: currency,
            value: itemValue(item),
            items: [ convertItem(item) ]
        };
    };
    return function (v) {
        if (v instanceof Restaumatic_Analytics_Tracking_Event.AddToCart) {
            return {
                name: "add_to_cart",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "price";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "item_name";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "item_list_id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "item_category";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(addToCart(v.value0))
            };
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.LocateMe) {
            return {
                name: "locate_me",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.unitEncode)(Data_Unit.unit)
            };
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.RemoveFromCart) {
            return {
                name: "remove_from_cart",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "price";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "item_name";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "item_list_id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "item_category";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(removeFromCart(v.value0))
            };
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.BeginCheckout) {
            return {
                name: "begin_checkout",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "price";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "item_name";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "item_list_id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "item_category";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(beginCheckout(v.value0))
            };
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.Purchase) {
            return {
                name: "purchase",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "value";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "transaction_id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "shipping";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "items";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "quantity";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
                    reflectSymbol: function () {
                        return "price";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
                    reflectSymbol: function () {
                        return "item_name";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "item_list_id";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "item_category";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))({
                    reflectSymbol: function () {
                        return "currency";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "coupon";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                    reflectSymbol: function () {
                        return "affiliation";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(purchase(v.value0))
            };
        };
        if (v instanceof Restaumatic_Analytics_Tracking_Event.SetCheckoutOption) {
            return {
                name: "set_checkout_option",
                value: Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                    reflectSymbol: function () {
                        return "selectedValue";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                    reflectSymbol: function () {
                        return "selectedOption";
                    }
                })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(setCheckoutOption(v.value0))
            };
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.AnalyticsV4 (line 63, column 28 - line 69, column 100): " + [ v.constructor.name ]);
    };
};
export {
    convertItem,
    itemValue,
    toPlatformEvent
};
//# sourceMappingURL=index.js.map
